// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  markupRequest: ['filter'],
  markupSuccess: ['data'],
  markupFailure: ['err'],

  markupCreateRequest: ['data'],
  markupCreateSuccess: ['data'],
  markupCreateFailure: ['err'],

  markupUpdateRequest: ['data'],
  markupUpdateSuccess: ['data'],
  markupUpdateFailure: ['err'],

  markupDeleteRequest: ['data'],
  markupDeleteSuccess: ['data'],
  markupDeleteFailure: ['err'],

  markupItemCreateRequest: ['data'],
  markupItemCreateSuccess: ['data'],
  markupItemCreateFailure: ['err'],

  markupItemUpdateRequest: ['data'],
  markupItemUpdateSuccess: ['data'],
  markupItemUpdateFailure: ['err'],

  markupItemDeleteRequest: ['data'],
  markupItemDeleteSuccess: ['data'],
  markupItemDeleteFailure: ['err'],

  markupItemGetRequest: ['data'],
  markupItemGetSuccess: ['data'],
  markupItemGetFailure: ['err']
})

export const MarkupTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: null,
  data_item: {
    value: 0,
    test_value: 0,
    id: '',
    attraction_id: '',
    created_at: '',
    updated_at: '',
    attraction: {
      type_name: '',
    },
    locations: [],
    final_price: '',
    is_expired: false,
    is_disabled: false,
    provider: '',
    attraction_packages: [],
    title: '',
    current_price: 0,
    preview_price: 0,
    currency_code: '',
  },
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) => state.merge({ fetching: true, success: null})

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null
  })

export const successItem = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data_item: data,
    err: null
  })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null, err: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null})

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.MARKUP_SUCCESS]: success,
  [Types.MARKUP_REQUEST]: request,
  [Types.MARKUP_FAILURE]: failure,

  [Types.MARKUP_CREATE_SUCCESS]: manipulateSuccess,
  [Types.MARKUP_CREATE_REQUEST]: manipulateRequest,
  [Types.MARKUP_CREATE_FAILURE]: manipulateFailure,

  [Types.MARKUP_UPDATE_SUCCESS]: manipulateSuccess,
  [Types.MARKUP_UPDATE_REQUEST]: manipulateRequest,
  [Types.MARKUP_UPDATE_FAILURE]: manipulateFailure,

  [Types.MARKUP_DELETE_SUCCESS]: manipulateSuccess,
  [Types.MARKUP_DELETE_REQUEST]: manipulateRequest,
  [Types.MARKUP_DELETE_FAILURE]: manipulateFailure,

  [Types.MARKUP_ITEM_CREATE_SUCCESS]: manipulateSuccess,
  [Types.MARKUP_ITEM_CREATE_REQUEST]: manipulateRequest,
  [Types.MARKUP_ITEM_CREATE_FAILURE]: manipulateFailure,

  [Types.MARKUP_ITEM_UPDATE_SUCCESS]: manipulateSuccess,
  [Types.MARKUP_ITEM_UPDATE_REQUEST]: manipulateRequest,
  [Types.MARKUP_ITEM_UPDATE_FAILURE]: manipulateFailure,

  [Types.MARKUP_ITEM_DELETE_SUCCESS]: manipulateSuccess,
  [Types.MARKUP_ITEM_DELETE_REQUEST]: manipulateRequest,
  [Types.MARKUP_ITEM_DELETE_FAILURE]: manipulateFailure,

  [Types.MARKUP_ITEM_GET_SUCCESS]: successItem,
  [Types.MARKUP_ITEM_GET_REQUEST]: request,
  [Types.MARKUP_ITEM_GET_FAILURE]: failure
})



// WEBPACK FOOTER //
// ./src/Redux/MarkupRedux.js